import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'


import TanstackQueryLayout from '../integrations/tanstack-query/layout'

import type { QueryClient } from '@tanstack/react-query'
import MainLayout from '@/layouts/main'
import {Toaster} from 'sonner'
import { useEffect } from 'react'
import { disableSplash } from '@/lib/utils'
import { DirectionProvider } from '@radix-ui/react-direction'
import NewLayout from '@/layouts/new'


interface MyRouterContext {
  queryClient: QueryClient
}

function Layout() {

  useEffect(()=> {
    if (location.pathname !== '/') {
      setTimeout(()=> disableSplash(), 1000)
    }
  }, [])

  return (
    <>
    <DirectionProvider dir="rtl">
      <NewLayout />
      <Toaster richColors position='bottom-left' className='font-sans' style={{
        fontFamily: 'Vazir',
      }}/>
      <TanstackQueryLayout />
      <TanStackRouterDevtools position="bottom-right" />
    </DirectionProvider>
    </>
  )
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => <Layout />
})
